require('@nathanvda/cocoon');
const ReactRailsUJS = require('react_ujs');

$(document).on('cocoon:after-insert', () => ReactRailsUJS.mountComponents());

export default {};
